<template>
  <div :class="['ed-card-table', {'open': isFlipped}]" :id="'card' + object.id">
    <div class="ed-card-table__recto" :class="{ 'no-checkbox' : !checkbox }">
      <div class="ed-card-table__function-trigger" @click="triggerCardFunction"></div>
      <checkbox :id="object.id" :value="object.id" @check="selectItem" @uncheck="unselectItem" v-if="checkbox"></checkbox>
      <span @click="toggleMechanics('card' + object.id)" class="ed-card-table__info-trigger">i</span>
      <div class="ed-card-table__illustration">
        <i :class="illustration"></i>
      </div>
      <div>
        <div class="ed-card-table__title" :class="{ 'padded-title' : !subtitle }">
          <span v-for="title in name" :class="{ 'ed-u-uppercase' : title.style === 'uppercase' }">{{ formatData(object, title.attribute) }} </span>
        </div>
        <div class="ed-card-table__subtitle" v-for="title in subtitle" :style="(title.style ? title.style(object) : null)">
          {{ title.label }} {{ formatData(object ,title.attribute) }}
        </div>
      </div>
      <div class="ed-card-table__picto-list" v-if="actions">
        <div v-for="action in actions" @click="action.function(object)" class="ed-card-table__picto" key="action" v-html="action.content"></div>
      </div>
    </div>
    <div class="ed-card-table__verso">
      <div class="ed-card-table__function-trigger ed-card-table__function-trigger--verso" @click="triggerCardFunction"></div>
      <div class="ed-card-table__verso-content">
        <button class="ed-card-table__close icon-close" @click="toggleMechanics('card' + object.id)"></button>
        <div class="ed-card-table__verso-title">
          <span v-for="title in name">{{ object[title.attribute] }} </span></div>
        <div class="ed-card-table__subtitle">
          <div v-for="item in subtitle" :style="item.style">{{ item.label }} {{ formatData(object, item.attribute) }}</div>
        </div>
        <div v-for="label in labels">
          <span class="ed-card-table__label">{{ label.name }} :</span>
          <span class="ed-card-table__info">{{ formatData(object, label.reference) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'CardTable',
    props: {
      object: Object,
      labels: Array,
      actions: Array,
      parentArray: String,
      checkbox: Boolean,
      name: Array,
      subtitle: Array,
      cardFunction: Function,
      illustration: String,
    },
    data() {
      return {
        isFlipped: false,
      };
    },
    watch: {
      object() {
        if(this.isFlipped) {
          this.toggleMechanics();
        }
      },
    },
    methods: {
      selectItem() {
        const i = this.$parent.$data[this.parentArray].findIndex(elmt => elmt.id === this.object.id);
        if (i === -1) {
          this.$parent.$data[this.parentArray].push(this.object);
        }
      },

      unselectItem(checkboxValue) {
        const i = this.$parent.$data[this.parentArray].findIndex(elmt => elmt.id === this.object.id);
        if (i !== -1) {
          this.$parent.$data[this.parentArray].splice(i, 1);
        }
      },

      toggleMechanics() {
        this.isFlipped = !this.isFlipped;
      },

      triggerCardFunction() {
        this.cardFunction(this.object);
      },

      /* Get the element attribute value even when it's an object's attribute */
      /* of an object's attribute of an object ... */
      formatData(elmt, targetAttribute) {
        const attrArray = targetAttribute.split('.');
        if (attrArray.length > 1) {
          let elmtArbo = elmt;
          for (let i = 0; i < attrArray.length; i += 1) {
            elmtArbo = elmtArbo[attrArray[i]];
          }
          if (!elmtArbo) {
            return 'Non renseigné';
          }
          return elmtArbo;
        }
        if (!elmt[targetAttribute]) {
          return 'Non renseigné';
        }
        return elmt[targetAttribute];
      },
    },
  };
</script>



// WEBPACK FOOTER //
// cardTable.vue?456e085a